import { REACTIONS } from "@/src/models/post.model";
import React from "react";
import { Image, Text } from "react-native";

type Props = Readonly<{ id: string | null | undefined; size?: number; className?: string; style?: any }>;

/** Animated Noto emoji for a reaction id; falls back to the text emoji. */
const ReactionGlyph = ({ id, size = 20, className, style }: Props) => {
  const reaction = REACTIONS.find((r) => r.id === id);
  if (!reaction) return null;
  if (reaction.asset) {
    return (
      <Image
        source={reaction.asset}
        accessibilityLabel={reaction.label}
        style={[{ width: size, height: size }, style]}
        className={className}
        resizeMode="contain"
      />
    );
  }
  return <Text style={[{ fontSize: size * 0.85 }, style]} className={className}>{reaction.emoji}</Text>;
};

export default ReactionGlyph;
